The input parameter for the `deleteUnpostedPositionProfile` mutation.
